import React from 'react';
import PropTypes from 'prop-types';
import { Form, DatePicker, Divider } from 'antd';
import RadioForChooseTypeOfFile from '../widgetsReporting/RadioForChooseTypeOfFile';

const { RangePicker } = DatePicker;
const MeetingReport = ({
  keyTab,
  extensionFile,
  setExtensionFile,
  typeOfReport
}) => {
  return (
    <div
      style={{
        width: '100%',
        alignItems: 'center',
        height: 'auto'
      }}
    >
      <RadioForChooseTypeOfFile
        keyTab={keyTab}
        extensionFile={extensionFile}
        setExtensionFile={setExtensionFile}
        typeOfReport={typeOfReport}
      />
      <Divider />
      <Form.Item name={['dates']}>
        <RangePicker />
      </Form.Item>
    </div>
  );
};
MeetingReport.propTypes = {
  keyTab: PropTypes.string.isRequired,
  extensionFile: PropTypes.string.isRequired,
  setExtensionFile: PropTypes.func.isRequired,
  typeOfReport: PropTypes.string.isRequired
};

export default MeetingReport;
